// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__J3_ZR","colMin":"styles_colMin__c8QA0","colCheckbox":"styles_colCheckbox__248UY"};